// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { TableRowProps } from '@material-ui/core';

import { ResourcePathArgs, useResourcePath } from '../../hooks/useResourcePath';
import { LinkableTableRow } from '../LinkableTableRow/LinkableTableRow';

export type ResourceTableRowProps = TableRowProps & ResourcePathArgs;

export const ResourceTableRow = ({
  routeRef,
  name,
  children,
  params,
  transform,
  ...tableRowProps
}: ResourceTableRowProps) => {
  const path = useResourcePath({
    routeRef,
    name,
    params,
    transform,
  });

  return (
    <LinkableTableRow {...tableRowProps} to={path || ''}>
      {children}
    </LinkableTableRow>
  );
};
